import { createAction, createSlice } from "@reduxjs/toolkit";

const allSubscriptionSlice = createSlice({
  name: "allSubscription",
  initialState: { data: [], pagination: [], processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data.data;
      state.pagination = action.payload.data.pagination;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = allSubscriptionSlice;
const allSubscriptionAction = createAction(name);

export {
  allSubscriptionAction,
  actions as allSubscriptionActions,
  reducer as allSubscriptionReducer,
};
